/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./imageAnchorPicker.vue?vue&type=template&id=5ca55a60&scoped=true"
import script from "./imageAnchorPicker.vue?vue&type=script&lang=js"
export * from "./imageAnchorPicker.vue?vue&type=script&lang=js"
import style0 from "./imageAnchorPicker.vue?vue&type=style&index=0&id=5ca55a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca55a60",
  null
  
)

export default component.exports